import {getLastSeenOptionByMinMax} from '../../../last-seen-filter/last-seen-filter.models';

class FilterSummaryComponent {
  constructor() {}

  $onInit() {
    this.filtersCount = this._getFilterCount();
    this.filters = this._getFilters();
  }

  _getFilterCount() {
    const {query, alerts, maintenance, lastCommunicated, securityGroups, tagFilters, accounts, lastSeen} = this.item;
    const tagFilterCount = Object.keys(tagFilters || {}).length;
    const queryCount = (query || []).length;
    const secCount = (securityGroups || []).length;
    const alertsCount = (alerts || []).length;
    const maintenCount = (maintenance || []).length;
    const comCount = (lastCommunicated || []).length;
    const accountCount = (accounts || []).length;
    const lastSeenCount = (lastSeen || []).length;
    return (
      tagFilterCount + queryCount + secCount + alertsCount + maintenCount + comCount + accountCount + lastSeenCount
    );
  }

  _getFilters() {
    const {
      query,
      alerts = [],
      maintenance = [],
      lastCommunicated = [],
      securityGroups = [],
      tagFilters,
      accounts = [],
      lastSeen = []
    } = this.item;
    let filters = [];
    const frindlyalerts = alerts.map(item => getfriendlyObject(item, this.search.alerts, 'alerts'));
    filters.push(...frindlyalerts);
    const frindlymaintenance = maintenance.map(item => getfriendlyObject(item, this.search.maintenance, 'maintenance'));
    filters.push(...frindlymaintenance);
    const frindlylastCommunicated = lastCommunicated.map(item =>
      getfriendlyObject(item, this.search.lastCommunicated, 'lastCommunicated')
    );
    filters.push(...frindlylastCommunicated);
    const frindlysecurityGroups = securityGroups.map(item =>
      getfriendlyObject(item, this.search.securityGroups, 'securityGroups')
    );
    filters.push(...frindlysecurityGroups);

    const frindlyAccounts = accounts.map(item => getfriendlyObject(item, this.search.accounts, 'accounts'));
    filters.push(...frindlyAccounts);

    const [savedLastSeen] = lastSeen || [];
    const LastSeenFilter = savedLastSeen ? getLastSeenOptionByMinMax(savedLastSeen.min, savedLastSeen.max) : '';
    return {
      queries: query,
      filters,
      tags: tagFilters,
      LastSeenFilter
    };
  }
}

const getfriendlyObject = (item, collection = [], type) => {
  const friendlyObject = {title: '', value: item.id, translateval: true};
  const fullObject = collection.find(obj => obj.id === item.id);
  if (!fullObject) {
    return friendlyObject;
  }
  switch (type) {
    case 'alerts': {
      return {
        ...friendlyObject,
        title: 'Alert',
        value: fullObject.label
      };
    }
    case 'maintenance': {
      return {
        ...friendlyObject,
        title: 'Maintenance',
        value: fullObject.label
      };
    }
    case 'lastCommunicated': {
      return {
        ...friendlyObject,
        title: fullObject.group,
        value: fullObject.label
      };
    }
    case 'securityGroups': {
      return {
        ...friendlyObject,
        title: 'Security Group',
        value: fullObject.name,
        translateval: false
      };
    }
    case 'accounts': {
      return {
        ...friendlyObject,
        title: 'Account',
        value: fullObject.name,
        translateval: false
      };
    }
  }

  return friendlyObject;
};
export default {
  template: require('./filter-summary.html'),
  controller: FilterSummaryComponent,
  controllerAs: 'vm',
  bindings: {
    item: '<',
    search: '<'
  }
};
